import { useState, useEffect } from "react"; 
import { db } from "../../firebase/config";

// firebase imports
import {collection, onSnapshot, query, where } from 'firebase/firestore'

export const useCollectionChat = (c, uid) => {
  const [documents, setDocuments] = useState([])

  useEffect(() => {
    const q = query(collection(db, c), where("hasRole", "array-contains", uid));
    const unsub = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach(doc => {
        results.push({...doc.data(), id:doc.id})
      })
      setDocuments(results)
    })

    return () => unsub()
  }, [c])
  return {documents}
}
